module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Communication/Mail-cd281bc8d63eb65bcb8eafc146a11e38.svg";